import { isNative } from './platform';

let appModule = null;

async function loadApp() {
  if (appModule) return appModule;
  const mod = await import('@capacitor/app');
  appModule = mod.App;
  return appModule;
}

function navigateFromUrl(router, rawUrl) {
  try {
    const url = new URL(rawUrl);
    const path = url.pathname + url.search;

    // Les liens partagés depuis l'app ont la forme https://www.ouicsport.fr/offer/<id>.
    // Le routeur ne déclare pas ce chemin : on le traduit vers la route nommée.
    const offerMatch = path.match(/^\/offer\/(.+?)(\?|$)/);
    if (offerMatch) {
      router.push({
        name: 'OfferDetailsPage',
        params: { id: decodeURIComponent(offerMatch[1]) },
      });
      return;
    }

    const cleanedPath = path.replace(/^\/+/, '/');
    if (cleanedPath && cleanedPath !== '/') {
      router.push(cleanedPath);
    }
  } catch (e) {
    console.warn('Deep link parse error', e, rawUrl);
  }
}

export async function initDeepLinks(router) {
  if (!isNative()) return;

  const App = await loadApp();

  // Application déjà lancée : Android transmet l'URL via handleOnNewIntent,
  // qui émet appUrlOpen.
  App.addListener('appUrlOpen', (event) => {
    navigateFromUrl(router, event.url);
  });

  // Démarrage à froid : quand l'application est fermée, Android place l'URL
  // dans l'Intent de lancement et n'émet JAMAIS appUrlOpen. Sans la lecture
  // ci-dessous, ouvrir un lien vers une offre depuis un message ou un e-mail
  // lançait bien l'application, mais sur l'accueil — le lien perdait sa
  // destination, ce qui est précisément le cas d'usage d'un lien profond.
  try {
    const launch = await App.getLaunchUrl();
    if (launch?.url) {
      navigateFromUrl(router, launch.url);
    }
  } catch (e) {
    console.warn('Lecture de l\'URL de lancement impossible', e);
  }
}
